module.exports = __webpack_public_path__ + "static/media/28.cc97e3b3.jpg";